import { SamplePack } from '@arpeggi/shared'
import { useEffect } from 'react'
import { useImmer } from 'use-immer'
import { saleIsExpired, saleIsLive } from '../utils'

const hasMintEndTime = (sp: SamplePack, isPresale: boolean) =>
  (isPresale ? sp?.edition?.preSaleEndTime : sp?.edition?.publicSaleEndTime) !== undefined

const DEFAULT_STATE = {
  mintHasExpired: true,
  mintSoldOut: true,
  mintIsLive: true
}

interface State {
  mintHasExpired: boolean
  mintSoldOut: boolean
  mintIsLive: boolean
}

interface Props {
  sp: SamplePack
  isPresale: boolean
  totalMinted: number
}

export const useMintCollectionState = ({ sp, isPresale, totalMinted }: Props) => {
  const [state, setState] = useImmer<State>(DEFAULT_STATE)

  const mintHasEndTime = hasMintEndTime(sp, isPresale)

  const updateVariables = () => {
    setState((draft) => {
      draft.mintHasExpired = mintHasEndTime && saleIsExpired(sp, isPresale)
      draft.mintSoldOut =
        sp?.edition && sp?.edition?.totalVolume > 0 && totalMinted === sp?.edition?.totalVolume
      draft.mintIsLive = saleIsLive(sp, isPresale)
    })
  }

  useEffect(() => {
    updateVariables()
    const interval = setInterval(() => updateVariables(), 1000)
    return () => clearInterval(interval)
  }, [sp, isPresale, updateVariables])

  return state
}
